import React, { useCallback } from "react";
import { Box, Container, Grid, Typography, Link, Stack, Divider, IconButton } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Logo } from "components/Logo/Logo";
import { getPrivacyFile } from "api/auth.api";
import { getFromLocalStorage } from "helpers/localstorage";
import imgNital from "../../assets/images/logo_nital.png";

const Footer = () => {
  const { agencyName } = (getFromLocalStorage() as any) || {};
  const spacing = agencyName === 'Nikon' || agencyName === 'Nital' ? 3 : 4;
  const spacingLogo = agencyName === 'Nikon' || agencyName === 'Nital' ? 2 : 4;
  const spacingnital = agencyName === 'Nikon' || agencyName === 'Nital' ? 4 : 0;

  const onPrivacyDownload = useCallback(() => {
    getPrivacyFile()
    .then(({payload, body }) => {
      const url = window.URL.createObjectURL(new Blob([body]));
      const link = document.createElement("a");
      link.href = url;
      link.download = "SmartCom Privacy.pdf";
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    })
    .catch(e => console.log('error get privacy', JSON.stringify(e)));
  }, []);

  const openSynesthesisPage = useCallback(() => {
    window.open("https://synesthesia.it/");
  }, []);

  return (
    <Box sx={{ backgroundColor: "#fff", color: "#161F2B", py: 6, width: '100%', paddingTop: '20px', paddingBottom: '15px' }}>
      <Container maxWidth="lg">
        <Grid container>
          {/* Logo e Social */}
          <Grid item xs={12} md={spacingLogo}>
            <Box display="flex" alignItems="center" mb={2}>
              <Link href={"/"} style={{ height: "50px" }}>
                <Logo />
              </Link>
            </Box>
            <Stack direction="row" spacing={1} mt={4} style={{ marginTop: '10px' }}>
              <IconButton
                component="a"
                href="https://www.facebook.com/profile.php?id=61566876986807"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.instagram.com/noleggio_su_misura"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.linkedin.com/showcase/noleggio-su-misura"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon />
              </IconButton>
            </Stack>
          </Grid>

          {/* Contatti */}
          <Grid item xs={12} md={spacing}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Smartcom Solutions Srl
            </Typography>
            <Stack spacing={1}>
              <Stack direction="row" spacing={1} alignItems="center">
                <LocationOnIcon fontSize="small" />
                <Typography variant="body2">
                  <Link href="https://www.google.com/maps?q=Via+Tunisia+5+%E2%80%93+10093+Collegno+(TO)" color="inherit" underline="hover" rel="noopener noreferrer">
                    Via Tunisia 5 – 10093 Collegno (TO) – Italia
                  </Link>
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <EmailIcon fontSize="small" />
                <Typography variant="body2"><Link href="mailto:info@noleggiosumisura.it" color="inherit" underline="hover">info@noleggiosumisura.it</Link></Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <PhoneIcon fontSize="small" />
                <Typography variant="body2"><Link href="tel:(+39) 011 4557949" color="inherit" underline="hover">(+39) 011 4557949</Link></Typography>
              </Stack>
            </Stack>
          </Grid>

          {
            (agencyName === 'Nikon' || agencyName === 'Nital') && (
              <Grid item xs={12} md={spacingnital} style={{ paddingLeft: '30px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2">
                      In partnership con:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" gutterBottom style={{ verticalAlign: 'middle' }}>
                      Nital spa
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} style={{ alignContent: "center", paddingLeft: '0' }}>
                    <img style={{ height: "40px", width: "auto" }} src={imgNital} alt="logo" />
                  </Grid>
                </Grid>
                <Stack spacing={1}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2">Via Vittime di Piazza Fontana 54<br/>10024 Moncaglieri (TO)</Typography>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2">tel. <Link href="tel:(+39) 011 81444" color="inherit" underline="hover">(+39) 011 81444</Link></Typography>
                  </Stack>
                </Stack>
              </Grid>
            )
          }

          {/* Link Privacy */}
          <Grid item xs={12} md={spacing}>
            <Stack spacing={1}>
              <Link
                href="https://www.noleggiosumisura.it/privacy-policy/"
                underline="hover"
                color="inherit"
                fontWeight="bold"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </Link>
              <Link
                underline="hover"
                color="inherit"
                fontWeight="bold"
              >
                <span
                  onClick={onPrivacyDownload}
                >
                  Scarica documento privacy
                </span>
              </Link>
            </Stack>
          </Grid>
          <Grid item xs={12} md={12} style={{ paddingTop: '15px' }}>
            <Stack spacing={1}>
              <Typography variant="body2">©2025 Smartcom Solutions Srl All rights reserved | P.IVA IT 12711040019 | Powerd by <Link><a onClick={openSynesthesisPage} >Synesthesia</a></Link></Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
